export const ORDER = Object.freeze({
  TAKE_OUT: "TakeOut",
  DELIVERY: "Delivery",
});
export const ORDER_NAME: any = Object.freeze({
  TakeOut: "Take Out",
  Delivery: "Delivery",
});

export const TIME_ZONES: any = Object.freeze({
  "Pacific Standard Time": "America/Los_Angeles",
  "Mountain Standard Time": "America/Denver",
  "Central Standard Time": "America/Chicago",
  "Atlantic Standard Time": "America/Halifax",
  "Newfoundland Standard Time": "America/St_Johns",
  "Eastern Standard Time": "America/New_York",
  "Alaska Standard Time": "America/Anchorage",
  "Hawaii-Aleutian Standard Time": "Pacific/Honolulu",
});

export const TAX_TYPE = {
  tax1: "GST",
  tax2: "PST",
  tax3: "Other",
};
